import { NgModule } from '@angular/core';
import { MainCmsComponents } from '@core/const';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { ChatLinkComponent } from './chat-link/chat-link.component';
import { ChatLinkComponentModule } from './chat-link/chat-link.module';
import { ChatMenuComponentModule } from './chat-menu/chat-menu-component.module';
import { ChatMenuMobileComponent } from './chat-menu/chat-menu-mobile/chat-menu-mobile.component';
import { ChatMenuMobileModule } from './chat-menu/chat-menu-mobile/chat-menu-mobile.module';
import { ScrollToTopComponentModule } from './scroll-to-top/scroll-to-top-component.module';
import { TalkMeComponentModule } from './talk-me/talk-me-component.module';
import { TalkMeComponent } from './talk-me/talk-me.component';

@NgModule({
  imports: [
    ChatLinkComponentModule,
    TalkMeComponentModule,
    ChatMenuMobileModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [MainCmsComponents.SdCMSChatLinkComponent]: {
          component: ChatLinkComponent,
        },
        [MainCmsComponents.SdCMSTalkMeComponent]: {
          component: TalkMeComponent,
        },
        [MainCmsComponents.SdCMSChatMobileMenuComponent]: {
          component: ChatMenuMobileComponent,
        },
      },
    }),
  ],
  exports: [
    ChatMenuComponentModule,
    ChatMenuMobileModule,
    ScrollToTopComponentModule,
    TalkMeComponentModule,
    ChatLinkComponentModule,
  ],
})
export class MainOnlineChatsUiModule {}
